import { Link, Modal } from '@hover/blueprint';
import { useDisclosure } from '@hover/blueprint/chakra';
import React from 'react';

import { CheckboxField } from 'src/shared/components/forms';
import type { ConsentPolicy } from 'src/shared/graphql/generated';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

interface ContactConsentPolicyFieldProps {
  policy: ConsentPolicy;
}

const ContactConsentPolicyField: React.FC<ContactConsentPolicyFieldProps> = ({
  policy,
}) => {
  const label = policy.summary || policy.content;
  const { isOpen, onClose, onOpen } = useDisclosure();
  const t = useTranslate(TranslationNamespace.SIGN_UP);

  const modalChildren = policy.summary ? (
    <>
      <Modal
        contentProps={{
          borderRadius: 10,
        }}
        header={t('hoverContactPolicy')}
        isOpen={isOpen}
        onClose={onClose}
      >
        {policy.content}
      </Modal>
      &nbsp;
      <Link
        as="button"
        cursor="pointer"
        onClick={onOpen}
        p={0}
        textDecoration="underline"
        type="button"
      >
        {t('hoverContactPolicy')}
      </Link>
    </>
  ) : null;
  return (
    <CheckboxField
      ariaLabel={label}
      data-testid="has-agreed-to-contact-policy"
      label=""
      name="contactPolicy.hasConsent"
    >
      {label}
      {modalChildren}
    </CheckboxField>
  );
};

export { ContactConsentPolicyField };
